import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

function VideoSlider() {
  const sliders = document.querySelectorAll('[data-video-slider]');
  const showcaseSliders = document.querySelectorAll('[data-video-showcase-slider]');

  if (!sliders.length && !showcaseSliders.length) {
    return;
  }

  sliders.forEach((slider) => {
    new Swiper(slider, {
      modules: [Navigation, Pagination],
      slidesPerView: 'auto',
      spaceBetween: 28,
      centeredSlides: true,
      loop: true,
      navigation: {
        prevEl: slider.querySelector('.video-slider__arrow--prev'),
        nextEl: slider.querySelector('.video-slider__arrow--next'),
      },
      pagination: {
        el: slider.querySelector('.video-slider__pagination'),
        clickable: true,
      },
      breakpoints: {
        768: {
          spaceBetween: 32,
        },
        1024: {
          spaceBetween: 36,
        },
      },
    });
  });

  showcaseSliders.forEach((slider) => {
    const wrapper = slider.closest('.slider-house');

    new Swiper(slider, {
      modules: [Navigation],
      slidesPerView: 1,
      spaceBetween: 24,
      loop: true,
      navigation: {
        prevEl: wrapper.querySelector('.video-showcase__secondary-arrow--prev'),
        nextEl: wrapper.querySelector('.video-showcase__secondary-arrow--next'),
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });
  });
}

export default VideoSlider;
